import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/Layout";
import { AuthProvider } from "@/lib/auth";
import AuthCallback from "@/components/AuthCallback";
import ProtectedAdminRoute from "@/components/ProtectedAdminRoute";
import Home from "@/pages/Home";
import About from "@/pages/About";
import GriefSupport from "@/pages/GriefSupport";
import Books from "@/pages/Books";
import Classes from "@/pages/Classes";
import RequestSupport from "@/pages/RequestSupport";
import Donate from "@/pages/Donate";
import DonateSuccess from "@/pages/DonateSuccess";
import Contact from "@/pages/Contact";
import AskChaplainDerrick from "@/pages/AskChaplainDerrick";
import FromDiagnosisToGoodbye from "@/pages/FromDiagnosisToGoodbye";
import Resources from "@/pages/Resources";
import BulkOrders from "@/pages/BulkOrders";
import SponsorABook from "@/pages/SponsorABook";
import OrganizationBookings from "@/pages/OrganizationBookings";
import Unsubscribed from "@/pages/Unsubscribed";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

const AppRoutes = () => {
  const location = useLocation();
  // CRITICAL: Detect session_id from URL fragment SYNCHRONOUSLY during render
  // (not in useEffect) so AuthCallback handles it before ProtectedRoute kicks in.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/grief-support" element={<GriefSupport />} />
        <Route path="/books" element={<Books />} />
        <Route path="/classes" element={<Classes />} />
        <Route path="/request-support" element={<RequestSupport />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/donate/success" element={<DonateSuccess />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/ask-chaplain-derrick" element={<AskChaplainDerrick />} />
        <Route path="/from-diagnosis-to-goodbye" element={<FromDiagnosisToGoodbye />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/bulk-orders" element={<BulkOrders />} />
        <Route path="/sponsor-a-book" element={<SponsorABook />} />
        <Route path="/organization-bookings" element={<OrganizationBookings />} />
        <Route path="/unsubscribed" element={<Unsubscribed />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/admin"
          element={
            <ProtectedAdminRoute>
              <Admin />
            </ProtectedAdminRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
